export function customConsoleLogging(env) {
  if (env === "production")
    console.log = () => {
      return;
    };
}
